import { render, staticRenderFns } from "./Take3Pay2.vue?vue&type=template&id=00d4b7e6&"
import script from "./Take3Pay2.vue?vue&type=script&lang=js&"
export * from "./Take3Pay2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports